import React, { useEffect, useRef, useContext, useState } from "react";
import { LanguageContext } from "./LanguageContext";

const AnimatedText = React.memo(
  ({ text }) => {
    const [displayText, setDisplayText] = useState("");

    useEffect(() => {
      let index = 0;

      const typeText = () => {
        setDisplayText((prevText) => prevText + text[index]);
        index++;

        if (index < text.length) {
          setTimeout(typeText, 40);
        }
      };

      setTimeout(typeText, 40);

      return () => {};
    }, [text]);

    return <span>{displayText}</span>;
  },
  (prevProps, nextProps) => prevProps.text === nextProps.text
);

const ChatBot = () => {
  const { language } = useContext(LanguageContext);
  const bots = [
    { id: 1, name: "guest#154" },
    { id: 2, name: "guest#42" },
    { id: 3, name: "guest#3299" },
    { id: 4, name: "guest#422" },
    { id: 5, name: "guest#1388" },
    { id: 6, name: "guest#400" },
    { id: 7, name: "guest#322" },
    { id: 8, name: "guest#426" },
    { id: 9, name: "guest#321" },
    { id: 10, name: "guest#4234" },
    { id: 11, name: "guest#3210" },
    { id: 12, name: "guest#15" },
    { id: 13, name: "guest#714" },
    { id: 14, name: "guest#984" },
    { id: 15, name: "guest#1134" },
    { id: 16, name: "guest#1420" },
    { id: 17, name: "guest#2155" },
  ];

  const conversations = [
    { id: 1, sender: bots[0].name, text: "Hey!" },
    { id: 2, sender: bots[1].name, text: "it s fake ?" },
    { id: 3, sender: bots[2].name, text: "Wtf ?" },
    { id: 4, sender: bots[3].name, text: "No i'dont think so . it s not fake" },
    { id: 5, sender: bots[0].name, text: "there are a killer on the room" },
    {
      id: 6,
      sender: bots[4].name,
      text: "Check the the last camera i saw something  guys !",
    },
    { id: 7, sender: bots[5].name, text: "lol" },
    { id: 8, sender: bots[6].name, text: "Did anyone check the basement?" },
    { id: 9, sender: bots[7].name, text: "I'm not going down there alone!" },
    {
      id: 10,
      sender: bots[8].name,
      text: "I saw a shadow moving in camera 3!",
    },
    {
      id: 11,
      sender: bots[9].name,
      text: "Is it just me or is it getting colder in here?",
    },
    {
      id: 12,
      sender: bots[10].name,
      text: "We need to stick together and keep an eye on all the cameras.",
    },
    {
      id: 13,
      sender: bots[11].name,
      text: "I think I heard a footstep on the first floor...",
    },
  ];

  const [messages, setMessages] = useState([]);
  const [scrollActive, setScrollActive] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const messageContainerRef = useRef(null);

  const scrollErrorMargin = 50;

  useEffect(() => {
    const messageContainerElement = messageContainerRef.current;

    if (messageContainerElement && scrollActive) {
      if (
        messageContainerElement.scrollTop +
          messageContainerElement.clientHeight +
          scrollErrorMargin >=
        messageContainerElement.scrollHeight
      ) {
        messageContainerElement.scrollTop =
          messageContainerElement.scrollHeight;
      }
    }
  }, [messages, scrollActive]);

  useEffect(() => {
    let index = 0;

    const sendMessage = () => {
      if (index >= conversations.length) {
        index = 0;
      }

      setMessages((prevMessages) => [...prevMessages, conversations[index]]);
      index++;

      setTimeout(sendMessage, 2000 + Math.random() * 6000);
    };

    setTimeout(sendMessage, 4000);

    return () => {};
  }, []);

  const handleScroll = () => {
    const messageContainerElement = messageContainerRef.current;

    if (messageContainerElement) {
      setScrollActive(
        messageContainerElement.scrollTop +
          messageContainerElement.clientHeight +
          scrollErrorMargin >=
          messageContainerElement.scrollHeight
      );
    }
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    if (inputValue.trim()) {
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          id: prevMessages.length + 1,
          sender: language === "en" ? "You" : "Vous",
          text: inputValue,
          className: "user-message",
        },
      ]);

      setInputValue("");
    }
  };

  return (
    <div className="chatbot" id="chatbot">
      <div>
        <h1 className="vb-text">
          {language === "en" ? ".viewers" : ".spectateurs"}
        </h1>
      </div>
      <div
        className="vb-text messages"
        id="message-container"
        ref={messageContainerRef}
        onScroll={handleScroll}
      >
        {messages.map((message) => (
          <div key={message.id} className={message.className}>
            <strong>{message.sender}:</strong>
            <AnimatedText text={message.text} />
          </div>
        ))}
      </div>
      <form className="form-content" onSubmit={handleFormSubmit}>
        <input
          className="text-area"
          type="text"
          value={inputValue}
          onChange={handleInputChange}
        />
        <button className="vb-text send-button" type="submit">
          {language === "en" ? "Send" : "Envoyer"}
        </button>
      </form>
    </div>
  );
};

export default ChatBot;
